/**
 * @file コンポーネント：フル動画ページフル動画プレイヤーアイコンリスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledContent = styled.div`
    position: absolute;
    bottom: 72px;
    left: 0;
    z-index: 6;
    width: 100%;
`;

export const StyledContentBalloon = styled.div`
    display: none;
    position: absolute;
    top: -47px;
    left: -134px;
    padding-bottom: 4px;
`;

export const StyledContentBalloonContainer = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px !important;
    padding: 6px;
    border: none;
    background-color: rgba(0, 0, 0, 0.3);
`;

export const StyledContentBalloonText = styled.span`
    width: 100%;
    margin-bottom: 4px;
    overflow: hidden;
    color: #ffffff;
    font-size: 13px;
    line-height: 16px;
    text-overflow: ellipsis;
    text-shadow: 0 0 3px #000000;
    white-space: nowrap;
`;

export const StyledContentBalloonTime = styled.span`
    color: #ffffff;
    font-size: 11px;
    line-height: 11px;
    text-shadow: 0 0 3px #000000;
`;

export const StyledContentIcon = styled.button`
    position: relative;
    padding: 0;
    border: none;
    background-color: transparent;
    font-size: 16px;
    line-height: 1;
    text-shadow: 0 0 3px #000000;

    &::after {
        content: "";
    }

    i {
        color: #fff;
        opacity: 0.5;
    }
`;

export const StyledContentList = styled.ol`
    position: relative;
    width: calc(100% - 32px);
    margin: 0 16px;
`;

export const StyledContentListItem = styled.li`
    position: absolute;
    bottom: 0;
    z-index: 2;
    margin-left: -8px;

    &:hover > div {
        display: block;
    }
`;
